<template lang="pug">
multiselect(
    track-by="id"
    label="name"
    :options="stockSelector"
    :internal-search="false"
    :value="value"
    @search-change="loadStocks"
    :loading="onLoading('fetch-stocks')"
    @select="onSelect"
    placeholder="Select stock"
    :disabled="disabled"
)
    template(slot="option" slot-scope="props")
        .clear
            small.clear.text-muted {{ props.option.type }}
            span.clear {{ props.option.name }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import stock from '@js/store/inventory-fnb/modules/stock';

export default {
    props: {
        value: {
            type: Object,
            default: () => null,
        },

        disabled: {
            type: Boolean,
            default: false,
        },

        outletId: {
            type: Number,
            required: true,
        },
    },

    computed: {
        ...mapGetters('stock', ['stocks', 'stockSelector']),
    },

    beforeCreate() {
        if (!this.$store.hasModule('stock')) {
            this.$store.registerModule('stock', stock);
        }
    },

    mounted() {
        this.loadStocks();
    },

    methods: {
        ...mapActions('stock', ['getStockList']),

        onSelect(stock) {
            this.$emit('select', stock);
        },

        loadStocks: _.debounce(function(query = '') {
            const params = {
                query,
                outlet_id: this.outletId,
            };

            this.getStockList(params);
        }, 500),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/selector/fnb-stock-selector.vue